import { useMutation } from '@tanstack/react-query';

import { type PracticeLocation, useRemovePracticeLocationOptions } from '@/entities/practice';
import { useConfirmDialogStore } from '@/shared/stores/confirm-dialog-store';
import { SettingsRowActionButton } from '@/shared/ui/settings/settings-row';

type Props = {
    location: PracticeLocation;
    // True while another row's editor is open elsewhere on the page.
    disabled?: boolean;
};

// Never rendered for the default location — the caller filters that out.
export function RemoveLocationButton({ location, disabled }: Props) {
    const removeLocation = useMutation(useRemovePracticeLocationOptions());
    const openConfirmDialog = useConfirmDialogStore((state) => state.open);

    const onClick = () => {
        openConfirmDialog({
            title: `Delete ${location.name} location?`,
            confirmText: 'Delete',
            cancelText: 'Cancel',
            // Solid Danger button, not the muted `destructive`.
            variant: 'danger',
            onConfirm: () => removeLocation.mutate(location.id),
        });
    };

    return (
        <SettingsRowActionButton
            aria-label={`Delete ${location.name}`}
            onClick={onClick}
            disabled={disabled || removeLocation.isPending}
        >
            Delete
        </SettingsRowActionButton>
    );
}
